import React from "react";
import PropTypes from "prop-types";
import { Container, Transition, Table } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import Fila from "./tabla/Fila";
import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";

const propTypes = {
  datos: PropTypes.array.isRequired
};

class Tabla extends React.Component {
  state = {
    column: "nombre",
    data: cloneDeep(this.props.datos),
    direction: "ascending",
    redirect: false,
    redirectTo: null
  };

  componentWillReceiveProps(nextProps, nextContext) {
    nextProps.filtros === null
      ? this.setState(state => ({
          data: sortBy(cloneDeep(nextProps.datos), [state.column])
        }))
      : this.setState({
          data: sortBy(cloneDeep(nextProps.datos), "edad"),
          column: "edad",
          direction: "ascending"
        });
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: sortBy(cloneDeep(data), [clickedColumn]),
        direction: "ascending"
      });

      return;
    }

    this.setState({
      data: cloneDeep(data).reverse(),
      direction: direction === "ascending" ? "descending" : "ascending"
    });
  };

  handleRowClick = idInscripcion =>
    this.setState(state => ({
      redirect: true,
      redirectTo: (
        <Redirect
          to={`/inscripciones-confirmadas/${
            this.props.idColegio
          }/${idInscripcion}`}
        />
      )
    }));

  render() {
    const { column, data, direction, redirect, redirectTo } = this.state;
    const { filtros } = this.props;

    return redirect ? (
      redirectTo
    ) : (
      <Transition.Group animation="scale" duration={250}>
        {!isEmpty(data) && (
          <Container fluid>
            <Table sortable celled structured selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign="center" colSpan={8}>
                    DATOS DEL ALUMNO
                    {filtros &&
                      `  (de ${filtros.desde} a ${filtros.hasta} años)`}
                  </Table.HeaderCell>
                </Table.Row>

                <Table.Row>
                  <Table.HeaderCell
                    sorted={column === "nombre" ? direction : null}
                    onClick={this.handleSort("nombre")}
                    content="Nombre"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "apellido1" ? direction : null}
                    onClick={this.handleSort("apellido1")}
                    content="Apellidos"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "edad" ? direction : null}
                    onClick={this.handleSort("edad")}
                    content="Edad"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "telefonos" ? direction : null}
                    onClick={this.handleSort("telefonos")}
                    content="Telefonos"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "servicios" ? direction : null}
                    onClick={this.handleSort("servicios")}
                    content="Servicios"
                    textAlign="center"
                  />
                  <Table.HeaderCell
                    sorted={column === "formaDePago" ? direction : null}
                    onClick={this.handleSort("formaDePago")}
                    content="Forma de Pago"
                    textAlign="center"
                  />
                  <Table.HeaderCell content="Horario" textAlign="center" />
                  <Table.HeaderCell content="Eliminar" textAlign="center" />
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {data.map(d => (
                  <Fila
                    key={d.idInscripcion}
                    handleClick={this.handleRowClick}
                    handleBorrarLinea={this.props.handleBorrarLinea}
                    handleFormaDePago={this.props.handleClickFormaDePago}
                    {...d}
                  />
                ))}
              </Table.Body>
            </Table>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

Tabla.propTypes = propTypes;

export default Tabla;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/listaInscripciones/Tabla.jsx